import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useTranslation } from "react-i18next";
import "flatpickr/dist/themes/material_blue.css";
import { map } from "lodash";
import DeleteModal from "../../components/Common/DeleteModal";
import {
  addServiceType,
  getServiceType,
  updateServiceType,
  deleteServiceType,
} from "../../store/actions";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SafeField from "helpers/SafeField";

const ServiceType = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { sertypes, loading } = useSelector(
    (state) => state.ObjectReducer
  );

  const [sertype, setSertype] = useState({});
  const [isRight, setIsRight] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  // -----------------------------------
  // Init
  // -----------------------------------
  useEffect(() => {
    dispatch(getServiceType(localStorage.getItem("userId")));
  }, [dispatch]);

  // -----------------------------------
  // Toggles
  // -----------------------------------
  const toggleRightCanvas = (row) => {
    if (row) {
      setSertype({
        id: row.id,
        serviceTypeId: row.serviceTypeId,
        serviceTypeTitle: row.serviceTypeTitle,
        agentId: row.agentId,
        isActive: row.isActive,
      });
      setIsEdit(true);
    } else {
      setSertype({});
      setIsEdit(false);
    }
    setIsRight((prev) => !prev);
  };

  const toggleDeleteModal = () => {
    setDeleteModal((prev) => !prev);
  };

  // -----------------------------------
  // CRUD
  // -----------------------------------
  const handleServiceTypeSubmit = (values) => {
    dispatch(addServiceType(values));
  };

  const onClickDelete = (row) => {
    setSertype(row);
    setDeleteModal(true);
  };

  const handleDeleteServiceType = () => {
    if (sertype?.id) {
      dispatch(deleteServiceType(sertype));
      setDeleteModal(false);
    }
  };

  const handleUpdate = (values) => {
    if (isEdit) {
      const updateData = {
        id: values.id,
        serviceTypeId: values.serviceTypeId,
        serviceTypeTitle: values.serviceTypeTitle,
        agentId: values.agentId,
        isActive: values.isActive,
      };
      dispatch(updateServiceType(updateData));
    }
    toggleRightCanvas();
  };

  // -----------------------------------
  // Render
  // -----------------------------------
  return (
    <>
      {loading && <div className="loading">Loading…</div>}
      <ToastContainer autoClose={2000} />

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteServiceType}
        onCloseClick={toggleDeleteModal}
      />

      <div className="page-content">
      

        <Container fluid>
          <Row className="mb20">
            <Col xl="6">
              <Breadcrumbs
                title={t("General Settings")}
                breadcrumbItem={t("Service Type")}
              />
            </Col>
          </Row>

          <Row>
          
            <Col xl="12">
              {/* ================= ADD ================= */}
              <Formik
                enableReinitialize
                initialValues={{
                  serviceTypeTitle: "",
                }}
                validationSchema={Yup.object({
                  serviceTypeTitle: Yup.string().required("Required"),
                })}
                onSubmit={handleServiceTypeSubmit}
              >
                {({ errors, touched, handleChange }) => (
                  <Form className="needs-validation">
                    <Card>
                      <CardBody>
                       
                        <Row>
                          <Col sm="3">
                            <FormGroup className="mb-3">
                              <Label>{t("Title *")}</Label>
                              <SafeField
                                name="serviceTypeTitle"
                                onChange={handleChange}
                                className={
                                  "form-control" +
                                  (errors.serviceTypeTitle &&
                                  touched.serviceTypeTitle
                                    ? " is-invalid"
                                    : "")
                                }
                              />
                              <ErrorMessage
                                name="serviceTypeTitle"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>

                          <Col sm="2">
                            <button
                              type="submit"
                              className="btn btn-primary w-md"
                              style={{ marginTop: 31 }}
                            >
                              Add
                            </button>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>

                    {/* ================= TABLE ================= */}
                    <Card>
                      <CardBody>
                        <h5 className="card-title">History</h5>

                        <div className="table-responsive">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Title</th>
                                <th>Action</th>
                              </tr>
                            </thead>

                            <tbody>
                              {map(sertypes, (row, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{row.serviceTypeTitle}</td>
                                  <td>
                                    <ActionEdit
                                      onClick={() =>
                                        toggleRightCanvas(row)
                                      }
                                    />
                                    <ActionDelete
                                      onClick={() => onClickDelete(row)}
                                    />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </CardBody>
                    </Card>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>

          {/* ================= UPDATE ================= */}
          <Offcanvas
            isOpen={isRight}
            direction="end"
            toggle={toggleRightCanvas}
          >
            <OffcanvasHeader toggle={toggleRightCanvas}>
              Update
            </OffcanvasHeader>

            <OffcanvasBody>
              <Formik
                enableReinitialize
                initialValues={{
                  id: sertype?.id,
                  serviceTypeId: sertype?.serviceTypeId,
                  serviceTypeTitle: sertype?.serviceTypeTitle,
                  agentId: sertype?.agentId,
                  isActive: sertype?.isActive,
                }}
                validationSchema={Yup.object({
                  serviceTypeTitle: Yup.string().required("Required"),
                })}
                onSubmit={handleUpdate}
              >
                {({ errors, touched, handleChange }) => (
                  <Form className="needs-validation">
                    <Row>
                      <Col sm="12">
                        <FormGroup className="mb-3">
                          <Label>{t("Title *")}</Label>
                          <SafeField
                            name="serviceTypeTitle"
                            onChange={handleChange}
                            className={
                              "form-control" +
                              (errors.serviceTypeTitle &&
                              touched.serviceTypeTitle
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="serviceTypeTitle"
                            component="div"
                            className="invalid-feedback"
                          />
                        </FormGroup>
                      </Col>

                      <Col sm="12">
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                        >
                          Update
                        </button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </OffcanvasBody>
          </Offcanvas>
        </Container>
      </div>
    </>
  );
};

ServiceType.propTypes = {
  sertypes: PropTypes.array,
  loading: PropTypes.any,
};

export default ServiceType;
